export default {
  activeBorderColor: Styles.color.primary,
  backgroundColor: Styles.color.cardBackground,
  birthdayLabelColor: Styles.color.grey.one,
  inactiveBorderColor: Styles.color.grey.four,
  placeholderColor: Styles.color.grey.one,
};
